var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadQrIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46163 0H0V43.0028H4.46163V0Z",
    fill: "#EA5554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0007 3.90625H55.5391V43.0029H60.0007V3.90625Z",
    fill: "#EA5554"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4315 38.5234H2.23047V43.0029H24.4315V38.5234Z",
    fill: "#EA5554"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 38.5234H37.7988V43.0029H59.9999V38.5234Z",
    fill: "#EA5554"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9997 3.90625V8.3857H24.3245L20.4339 4.47962H4.46128V8.3857H2.23047V3.90625H59.9997Z",
    fill: "#EA5554"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9836 4.47946H2.23047V0H22.522L26.4304 3.90609L26.4839 3.97776L26.9836 4.47946Z",
    fill: "#EA5554"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8939 8.38554H24.3264L20.4358 4.47946L18.5977 2.65184L21.2389 0H22.5239L26.4323 3.90609L26.4858 3.97776L26.9855 4.47946L30.8939 8.38554Z",
    fill: "#EA5554"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8913 25.2998H28.4297V50.6894H32.8913V25.2998Z",
    fill: "#EA5554"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8913 36.4985H28.4297V40.978H32.8913V36.4985Z",
    fill: "#EA5554"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8929 57.9997L25.5568 52.7319L20.2207 47.4819H30.8929H41.5473L36.2112 52.7319L30.8929 57.9997Z",
    fill: "#EA5554"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadQrIcon);
export default __webpack_public_path__ + "static/media/download-qr-icon.cc3ac09fb01f5c3fe184f6071cc7b311.svg";
export { ForwardRef as ReactComponent };